import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=f71f1ce4"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=f71f1ce4&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f71f1ce4')) {
      api.createRecord('f71f1ce4', component.options)
    } else {
      api.reload('f71f1ce4', component.options)
    }
    module.hot.accept("./Inventory.vue?vue&type=template&id=f71f1ce4", function () {
      api.rerender('f71f1ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inventory/Inventory.vue"
export default component.exports